import { FC } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import home from "../../assets/images/svgs/home-breadcrumb.svg";
import arrow from "../../assets/images/svgs/breadcrumb-arrow.svg";
import { siteRoutes } from "utils/helpers/enums/routes";

interface BreadcrumbProps {
  links: AmbassadorBreadcrumbLink[];
}

export interface AmbassadorBreadcrumbLink {
  title: string;
  path: string;
  state?: any;
}

const AmbassadorBreadcrumb: FC<BreadcrumbProps> = ({ links }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleNavigation = (link: AmbassadorBreadcrumbLink) => {
    const { path: route = "", state = null } = link;
    if (route.split("?")[0] === pathname) return;
    navigate(route, { state });
  };

  return (
    <div className="flex items-center gap-2 flex-wrap py-2 sm:py-4">
      <img
        src={home}
        alt="Home"
        className="cursor-pointer"
        onClick={() => navigate(siteRoutes.ambassadorHome)}
      />
      <img src={arrow} alt="Arrow" className="mx-2" />
      {links.map((link, index) => {
        return (
          <div key={index} className="flex items-center">
            {index > 0 && <img src={arrow} alt="Arrow" className="mx-2" />}
            <span
              className={`text-sm font-normal cursor-pointer ${
                pathname === link.path.split("?")[0]
                  ? "text-ambassadorBlue"
                  : "text-lightgray-medium"
              }`}
              onClick={() => handleNavigation(link)}
            >
              {link.title}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default AmbassadorBreadcrumb;
